module.exports = __webpack_public_path__ + "static/Admin-0ccef3ff06fea01a90f3380e0b769e0c.png";